import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from '@mui/material';
import '../public/css/00_index.css';
import '../public/css/01_angular-material.css';
import '../public/css/02_materialize.css';
import '../public/css/03_animate.css';
import '../public/css/04_widgets.css';
import '../public/css/05_revenue.css';
import '../public/css/06_users.css';
import '../public/css/07_transactions.css';
import '../public/css/08_print.css';
import '../public/css/09_tables.css';
import '../public/css/10_material.css';
import '../public/css/11_icons.css';
import '../public/css/12_fonts.css';
import '../public/css/13_documents.css';
import '../public/css/14_core.css';
import '../public/css/15_animations.css';
import '../public/css/16_alignment.css';
import { RootErrorBoundary } from '/src/components';
import { RootContextProvider } from '/src/context';
import { AppRoutes } from '/src/routes';
import { theme } from '/src/theme';

const rootElement = document.getElementById('app');

rootElement &&
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <RootContextProvider>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <RootErrorBoundary>
              <AppRoutes />
              <ToastContainer
                position="top-right"
                autoClose={1750}
                hideProgressBar={false}
                newestOnTop={false}
                pauseOnFocusLoss={false}
                draggable={false}
                closeOnClick
                pauseOnHover
              />
            </RootErrorBoundary>
          </ThemeProvider>
        </BrowserRouter>
      </RootContextProvider>
    </React.StrictMode>
  );
